import React, { useState } from "react";
import cn from "classnames";
import styles from "./ProfileInformation.module.sass";
import Item from "../Item";
import Card from "../../../components/Card";
import TextInput from "../../../components/TextInput";
import Dropdown from "../../../components/Dropdown";
import PhoneInput from "../../../components/PhoneInput";

// Options pour les dropdowns
const SEX_OPTIONS = [
    { value: 'M', title: 'Masculin' },
    { value: 'F', title: 'Feminin' },
];

const NATIONALITY_OPTIONS = [
    { value: '1', title: 'Française' }, 
    { value: '2', title: 'Union Européenne' },
    { value: '3', title: 'Etranger hors Union Européenne' },
];

const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
};

const ProfileInformation = ({ className, data, updateData, currentStep }) => {
  // Utiliser directement les données de l'étudiant transmises par le parent
  const studentData = data?.student || {};

  // Gestionnaires pour les changements de données
  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    
    // Mettre à jour les données personnelles
    if (updateData) {
      updateData('personalInfo', { ...data.personalInfo, [name]: value });
    }
  };

  const handleDropdownChange = (name, value) => {
    // Mettre à jour les données personnelles
    if (updateData) {
      updateData('personalInfo', { ...data.personalInfo, [name]: value });
    }
  };

  // Fusionner les données de l'étudiant avec les modifications en cours
  const currentData = { ...studentData, ...data.personalInfo };

  return (
    <Card className={cn(styles.card, className)} title="Informations personnelles" classTitle="title-green">
      <div className={styles.group}>
        <TextInput
          className={styles.field}
          label="Nom"
          name="last_name"
          type="text"
          placeholder="Nom de l'élève"
          value={currentData?.last_name || ''}
          onChange={handleStudentChange}
          required
        />
        <TextInput
          className={styles.field}
          label="Nom d'usage"
          name="usage_name"
          type="text"
          placeholder="Nom d'usage"
          value={currentData?.usage_name || ''}
          onChange={handleStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Prénom"
          name="first_name"
          type="text"
          placeholder="Prénom de l'élève"
          value={currentData?.first_name || ''}
          onChange={handleStudentChange}
          required
        />
        <div className={styles.field}>
          <Dropdown
            className={styles.dropdown}
            label="Sexe"
            name="sex"
            required
            options={SEX_OPTIONS}
            setValue={(option) => handleDropdownChange('sex', option.value)}
            value={SEX_OPTIONS.find(opt => opt.value === currentData?.sex) || ''}
          />
        </div>
        <div className={styles.field}>
          <Dropdown
            className={styles.dropdown}
            label="Nationalité"
            name="nationality"
            options={NATIONALITY_OPTIONS}
            setValue={(option) => handleDropdownChange('nationality', option.value)}
            value={NATIONALITY_OPTIONS.find(opt => opt.value === currentData?.nationality) || ''}
          />
        </div>
        <TextInput
          className={styles.field}
          label="Date de naissance"
          name="birth_date"
          type="date"
          value={formatDateForInput(currentData?.birth_date)}
          onChange={handleStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Commune de naissance"
          name="birth_place"
          type="text"
          placeholder="Ville de naissance"
          value={currentData?.birth_place || ''}
          onChange={handleStudentChange}
        />
        <TextInput
          className={styles.field}
          label="Département de naissance"
          name="birth_department"
          type="number"
          placeholder="Ex: 75"
          value={currentData?.birth_department || ''}
          onChange={handleStudentChange}
        />
      </div>
    </Card>
  );
};

export default ProfileInformation;
